// extracted by mini-css-extract-plugin
export default {"split":"sidebar_split__6aDFY","active":"sidebar_active__EG9VQ"};